import { SvgIcon } from '@mui/material';
import { Component } from 'react';

class IconeAcordao extends Component {
    render() {
        return (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 12.143 14.996"
                width="24"
                height="24"
                {...this.props}
            >
                <g
                    stroke="inherit"
                    strokeWidth=".265"
                >
                    <path d="M.132.174v13.985h6.213L3.747 11.56l4.937-4.937 2.587 2.587V4.237L7.166.133z" />
                    <path
                        d="M6.416 1.213v3.851h3.898z"
                        fill="#fff"
                    />
                </g>
                <path
                    d="M6.794 10.64l4.17 4.169.992-.992-4.158-4.158zM8.306 9.175l1.843 1.842.697-.697L8.99 8.466zM5.618 11.821l1.843 1.843.697-.697-1.855-1.855z"
                    stroke="inherit"
                    strokeWidth=".265"
                />
            </SvgIcon>
        );
    }
}

export default IconeAcordao;
